import api from './api'

export type IncidentPriority = 'LOW' | 'MEDIUM' | 'HIGH' | 'CRITICAL'
export type IncidentStatus = 'OPEN' | 'ASSIGNED' | 'ENROUTE' | 'ONSCENE' | 'RESOLVED' | 'CANCELLED'
export type AssignmentStatus = 'ASSIGNED' | 'ENROUTE' | 'ONSCENE' | 'CLEAR'

export interface Incident {
    id: number
    title: string
    description?: string
    type?: string
    priority: IncidentPriority
    status: IncidentStatus
    source: string
    createdAt: string
}

export interface SuggestedUnit {
    userId: string
    callsign?: string
    distanceMeters: number
    etaSeconds: number
}

export interface Assignment {
    id: number
    incidentId: number
    userId: string
    callsign?: string
    status: AssignmentStatus
    etaSeconds?: number
}

export interface IncidentRequest {
    title: string
    description?: string
    type?: string
    priority?: IncidentPriority
    lat?: number
    lon?: number
}

export const dispatchService = {
    async listActive(limit = 100): Promise<Incident[]> {
        return (await api.get<Incident[]>('/api/v1/dispatch/incidents', { params: { limit } })).data
    },
    async create(req: IncidentRequest): Promise<Incident> {
        return (await api.post<Incident>('/api/v1/dispatch/incidents', req)).data
    },
    async nearest(id: number, limit = 5): Promise<SuggestedUnit[]> {
        return (await api.get<SuggestedUnit[]>(`/api/v1/dispatch/incidents/${id}/nearest`, {
            params: { limit },
        })).data
    },
    async assign(id: number, userId: string): Promise<Assignment> {
        return (await api.post<Assignment>(`/api/v1/dispatch/incidents/${id}/assign`, { userId })).data
    },
    async assignments(id: number): Promise<Assignment[]> {
        return (await api.get<Assignment[]>(`/api/v1/dispatch/incidents/${id}/assignments`)).data
    },
    async updateStatus(assignmentId: number, status: AssignmentStatus): Promise<Assignment> {
        return (await api.put<Assignment>(`/api/v1/dispatch/assignments/${assignmentId}/status`, { status })).data
    },
    async resolve(id: number): Promise<Incident> {
        return (await api.post<Incident>(`/api/v1/dispatch/incidents/${id}/resolve`)).data
    },
}
